"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrpcWebError = exports.GrpcWebImpl = exports.AdTrackServiceAdTrackRequestDesc = exports.AdTrackServiceDesc = exports.AdTrackServiceClientImpl = exports.ClientAdFreshStatus = exports.ClientRankingFeatures = exports.ClientRankingModelOutput = exports.FailureToDeliverReason = exports.AdTrackItem = exports.InventoryTrackRequest = exports.TrackRequest = exports.ClientAdFreshStatus_FreshStatus = exports.ClientRankingFeatures_PlaybackAudio = exports.ClientRankingFeatures_DeviceOs = exports.FailureToDeliverReason_Reason = exports.TrackFiringMechanism = exports.AdTrackTriggerType = void 0;
/* eslint-disable */
const grpc_web_1 = require("@improbable-eng/grpc-web");
const track_response_1 = require("./track_response");
const browser_headers_1 = require("browser-headers");
const ad_request_1 = require("./ad_request");
const ad_kit_feature_flags_1 = require("./ad_kit_feature_flags");
const impression_data_1 = require("./track/impression_data");
const rtb_track_data_1 = require("./track/rtb_track_data");
const ad_insertion_config_1 = require("./ad_insertion_config");
const inventory_request_1 = require("./inventory_request");
const client_crawl_attempt_1 = require("./client_crawl_attempt");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../google/protobuf/wrappers");
var AdTrackTriggerType;
(function (AdTrackTriggerType) {
    /** UNSET_AD_END - If unset we will treat it as sending track on ad end */
    AdTrackTriggerType[AdTrackTriggerType["UNSET_AD_END"] = 0] = "UNSET_AD_END";
    AdTrackTriggerType[AdTrackTriggerType["TOP_SNAP_PLAYBACK_STARTED"] = 1] = "TOP_SNAP_PLAYBACK_STARTED";
    AdTrackTriggerType[AdTrackTriggerType["AD_ATTACHMENT_TRIGGERED"] = 2] = "AD_ATTACHMENT_TRIGGERED";
    /** AGGREGATION - this indicates a server generated aggregation event */
    AdTrackTriggerType[AdTrackTriggerType["AGGREGATION"] = 3] = "AGGREGATION";
    AdTrackTriggerType[AdTrackTriggerType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AdTrackTriggerType = exports.AdTrackTriggerType || (exports.AdTrackTriggerType = {}));
var TrackFiringMechanism;
(function (TrackFiringMechanism) {
    TrackFiringMechanism[TrackFiringMechanism["UNSET_TRACK_FIRING_MECHANISM"] = 0] = "UNSET_TRACK_FIRING_MECHANISM";
    TrackFiringMechanism[TrackFiringMechanism["GREEDY_TRACK"] = 1] = "GREEDY_TRACK";
    TrackFiringMechanism[TrackFiringMechanism["DURABLE_JOB_TRACK"] = 2] = "DURABLE_JOB_TRACK";
    TrackFiringMechanism[TrackFiringMechanism["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TrackFiringMechanism = exports.TrackFiringMechanism || (exports.TrackFiringMechanism = {}));
var FailureToDeliverReason_Reason;
(function (FailureToDeliverReason_Reason) {
    FailureToDeliverReason_Reason[FailureToDeliverReason_Reason["UNKNOWN_REASON"] = 0] = "UNKNOWN_REASON";
    FailureToDeliverReason_Reason[FailureToDeliverReason_Reason["AD_METADATA_EXPIRED"] = 1] = "AD_METADATA_EXPIRED";
    FailureToDeliverReason_Reason[FailureToDeliverReason_Reason["AD_RENDER_DATA_IMCOMPLETE"] = 2] = "AD_RENDER_DATA_IMCOMPLETE";
    FailureToDeliverReason_Reason[FailureToDeliverReason_Reason["AD_MEDIA_FAIL_TO_FETCH"] = 3] = "AD_MEDIA_FAIL_TO_FETCH";
    FailureToDeliverReason_Reason[FailureToDeliverReason_Reason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FailureToDeliverReason_Reason = exports.FailureToDeliverReason_Reason || (exports.FailureToDeliverReason_Reason = {}));
var ClientRankingFeatures_DeviceOs;
(function (ClientRankingFeatures_DeviceOs) {
    ClientRankingFeatures_DeviceOs[ClientRankingFeatures_DeviceOs["UNKNOWN_DEVICE_OS"] = 0] = "UNKNOWN_DEVICE_OS";
    ClientRankingFeatures_DeviceOs[ClientRankingFeatures_DeviceOs["IOS"] = 1] = "IOS";
    ClientRankingFeatures_DeviceOs[ClientRankingFeatures_DeviceOs["ANDROID"] = 2] = "ANDROID";
    ClientRankingFeatures_DeviceOs[ClientRankingFeatures_DeviceOs["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ClientRankingFeatures_DeviceOs = exports.ClientRankingFeatures_DeviceOs || (exports.ClientRankingFeatures_DeviceOs = {}));
var ClientRankingFeatures_PlaybackAudio;
(function (ClientRankingFeatures_PlaybackAudio) {
    ClientRankingFeatures_PlaybackAudio[ClientRankingFeatures_PlaybackAudio["UNKNOWN_PLAYBACK_AUDIO"] = 0] = "UNKNOWN_PLAYBACK_AUDIO";
    ClientRankingFeatures_PlaybackAudio[ClientRankingFeatures_PlaybackAudio["ON"] = 1] = "ON";
    ClientRankingFeatures_PlaybackAudio[ClientRankingFeatures_PlaybackAudio["OFF"] = 2] = "OFF";
    ClientRankingFeatures_PlaybackAudio[ClientRankingFeatures_PlaybackAudio["HEADPHONE"] = 3] = "HEADPHONE";
    ClientRankingFeatures_PlaybackAudio[ClientRankingFeatures_PlaybackAudio["MUTE_OVERRIDDEN"] = 4] = "MUTE_OVERRIDDEN";
    ClientRankingFeatures_PlaybackAudio[ClientRankingFeatures_PlaybackAudio["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ClientRankingFeatures_PlaybackAudio = exports.ClientRankingFeatures_PlaybackAudio || (exports.ClientRankingFeatures_PlaybackAudio = {}));
var ClientAdFreshStatus_FreshStatus;
(function (ClientAdFreshStatus_FreshStatus) {
    ClientAdFreshStatus_FreshStatus[ClientAdFreshStatus_FreshStatus["FRESH"] = 0] = "FRESH";
    ClientAdFreshStatus_FreshStatus[ClientAdFreshStatus_FreshStatus["STALE"] = 1] = "STALE";
    ClientAdFreshStatus_FreshStatus[ClientAdFreshStatus_FreshStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ClientAdFreshStatus_FreshStatus = exports.ClientAdFreshStatus_FreshStatus || (exports.ClientAdFreshStatus_FreshStatus = {}));
function createBaseTrackRequest() {
    return {
        encryptedUserTrackData: new Uint8Array(),
        application: undefined,
        preferences: undefined,
        device: undefined,
        network: undefined,
        inventoryTrackRequests: [],
        isDebug: undefined,
        creationTimestampMs: undefined,
        numberOfAttempts: undefined,
        serializedV1Track: undefined,
        adkitFeatureFlags: undefined,
        encryptedUserData: new Uint8Array(),
        clientRequestId: new Uint8Array(),
        trackFiringMechanism: 0,
    };
}
exports.TrackRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encryptedUserTrackData.length !== 0) {
            writer.uint32(10).bytes(message.encryptedUserTrackData);
        }
        if (message.application !== undefined) {
            ad_request_1.Application.encode(message.application, writer.uint32(18).fork()).ldelim();
        }
        if (message.preferences !== undefined) {
            ad_request_1.Preferences.encode(message.preferences, writer.uint32(26).fork()).ldelim();
        }
        if (message.device !== undefined) {
            ad_request_1.Device.encode(message.device, writer.uint32(34).fork()).ldelim();
        }
        if (message.network !== undefined) {
            ad_request_1.Network.encode(message.network, writer.uint32(42).fork()).ldelim();
        }
        for (const v of message.inventoryTrackRequests) {
            exports.InventoryTrackRequest.encode(v, writer.uint32(50).fork()).ldelim();
        }
        if (message.isDebug !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isDebug }, writer.uint32(58).fork()).ldelim();
        }
        if (message.creationTimestampMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.creationTimestampMs }, writer.uint32(66).fork()).ldelim();
        }
        if (message.numberOfAttempts !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.numberOfAttempts }, writer.uint32(74).fork()).ldelim();
        }
        if (message.serializedV1Track !== undefined) {
            wrappers_1.StringValue.encode({ value: message.serializedV1Track }, writer.uint32(82).fork()).ldelim();
        }
        if (message.adkitFeatureFlags !== undefined) {
            ad_kit_feature_flags_1.AdKitFeatureFlags.encode(message.adkitFeatureFlags, writer.uint32(90).fork()).ldelim();
        }
        if (message.encryptedUserData.length !== 0) {
            writer.uint32(98).bytes(message.encryptedUserData);
        }
        if (message.clientRequestId.length !== 0) {
            writer.uint32(106).bytes(message.clientRequestId);
        }
        if (message.trackFiringMechanism !== 0) {
            writer.uint32(112).int32(message.trackFiringMechanism);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTrackRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.encryptedUserTrackData = reader.bytes();
                    break;
                case 2:
                    message.application = ad_request_1.Application.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.preferences = ad_request_1.Preferences.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.device = ad_request_1.Device.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.network = ad_request_1.Network.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.inventoryTrackRequests.push(exports.InventoryTrackRequest.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.isDebug = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.creationTimestampMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.numberOfAttempts = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.serializedV1Track = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.adkitFeatureFlags = ad_kit_feature_flags_1.AdKitFeatureFlags.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.encryptedUserData = reader.bytes();
                    break;
                case 13:
                    message.clientRequestId = reader.bytes();
                    break;
                case 14:
                    message.trackFiringMechanism = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTrackRequest();
        message.encryptedUserTrackData =
            object.encryptedUserTrackData ?? new Uint8Array();
        message.application =
            object.application !== undefined && object.application !== null
                ? ad_request_1.Application.fromPartial(object.application)
                : undefined;
        message.preferences =
            object.preferences !== undefined && object.preferences !== null
                ? ad_request_1.Preferences.fromPartial(object.preferences)
                : undefined;
        message.device =
            object.device !== undefined && object.device !== null
                ? ad_request_1.Device.fromPartial(object.device)
                : undefined;
        message.network =
            object.network !== undefined && object.network !== null
                ? ad_request_1.Network.fromPartial(object.network)
                : undefined;
        message.inventoryTrackRequests =
            object.inventoryTrackRequests?.map((e) => exports.InventoryTrackRequest.fromPartial(e)) || [];
        message.isDebug = object.isDebug ?? undefined;
        message.creationTimestampMs = object.creationTimestampMs ?? undefined;
        message.numberOfAttempts = object.numberOfAttempts ?? undefined;
        message.serializedV1Track = object.serializedV1Track ?? undefined;
        message.adkitFeatureFlags =
            object.adkitFeatureFlags !== undefined &&
                object.adkitFeatureFlags !== null
                ? ad_kit_feature_flags_1.AdKitFeatureFlags.fromPartial(object.adkitFeatureFlags)
                : undefined;
        message.encryptedUserData = object.encryptedUserData ?? new Uint8Array();
        message.clientRequestId = object.clientRequestId ?? new Uint8Array();
        message.trackFiringMechanism = object.trackFiringMechanism ?? 0;
        return message;
    },
};
function createBaseInventoryTrackRequest() {
    return {
        requestId: new Uint8Array(),
        inventoryType: 0,
        inventoryId: undefined,
        items: [],
        adRequestClientId: new Uint8Array(),
        inventorySubType: 0,
    };
}
exports.InventoryTrackRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.requestId.length !== 0) {
            writer.uint32(10).bytes(message.requestId);
        }
        if (message.inventoryType !== 0) {
            writer.uint32(16).int32(message.inventoryType);
        }
        if (message.inventoryId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.inventoryId }, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.items) {
            exports.AdTrackItem.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.adRequestClientId.length !== 0) {
            writer.uint32(42).bytes(message.adRequestClientId);
        }
        if (message.inventorySubType !== 0) {
            writer.uint32(48).int32(message.inventorySubType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInventoryTrackRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.requestId = reader.bytes();
                    break;
                case 2:
                    message.inventoryType = reader.int32();
                    break;
                case 3:
                    message.inventoryId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.items.push(exports.AdTrackItem.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.adRequestClientId = reader.bytes();
                    break;
                case 6:
                    message.inventorySubType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseInventoryTrackRequest();
        message.requestId = object.requestId ?? new Uint8Array();
        message.inventoryType = object.inventoryType ?? 0;
        message.inventoryId = object.inventoryId ?? undefined;
        message.items = object.items?.map((e) => exports.AdTrackItem.fromPartial(e)) || [];
        message.adRequestClientId = object.adRequestClientId ?? new Uint8Array();
        message.inventorySubType = object.inventorySubType ?? 0;
        return message;
    },
};
function createBaseAdTrackItem() {
    return {
        encryptedAdTrackData: new Uint8Array(),
        impressionData: undefined,
        sessionId: undefined,
        trackSeqNum: undefined,
        attemptSeqNum: undefined,
        clientRankingNoShow: undefined,
        clientRankingModelOutput: undefined,
        clientRankingFeatures: undefined,
        opportunityRequestId: new Uint8Array(),
        RTBTrackData: undefined,
        failureToDeliverReason: undefined,
        adInsertionConfig: undefined,
        adFreshStatus: undefined,
        displayedPreRollAdInfo: undefined,
        serveItemId: new Uint8Array(),
        clientAttemptedCrawls: [],
        isIntermediateTrack: undefined,
        adTrackTriggerType: 0,
        adViewSeqNum: undefined,
        isSpectrumTrackEnabled: undefined,
    };
}
exports.AdTrackItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encryptedAdTrackData.length !== 0) {
            writer.uint32(10).bytes(message.encryptedAdTrackData);
        }
        if (message.impressionData !== undefined) {
            impression_data_1.ImpressionData.encode(message.impressionData, writer.uint32(18).fork()).ldelim();
        }
        if (message.sessionId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.sessionId }, writer.uint32(26).fork()).ldelim();
        }
        if (message.trackSeqNum !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.trackSeqNum }, writer.uint32(34).fork()).ldelim();
        }
        if (message.attemptSeqNum !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.attemptSeqNum }, writer.uint32(42).fork()).ldelim();
        }
        if (message.clientRankingNoShow !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.clientRankingNoShow }, writer.uint32(50).fork()).ldelim();
        }
        if (message.clientRankingModelOutput !== undefined) {
            exports.ClientRankingModelOutput.encode(message.clientRankingModelOutput, writer.uint32(58).fork()).ldelim();
        }
        if (message.clientRankingFeatures !== undefined) {
            exports.ClientRankingFeatures.encode(message.clientRankingFeatures, writer.uint32(66).fork()).ldelim();
        }
        if (message.opportunityRequestId.length !== 0) {
            writer.uint32(74).bytes(message.opportunityRequestId);
        }
        if (message.RTBTrackData !== undefined) {
            rtb_track_data_1.RTBTrackData.encode(message.RTBTrackData, writer.uint32(82).fork()).ldelim();
        }
        if (message.failureToDeliverReason !== undefined) {
            exports.FailureToDeliverReason.encode(message.failureToDeliverReason, writer.uint32(90).fork()).ldelim();
        }
        if (message.adInsertionConfig !== undefined) {
            ad_insertion_config_1.AdInsertionConfig.encode(message.adInsertionConfig, writer.uint32(98).fork()).ldelim();
        }
        if (message.adFreshStatus !== undefined) {
            exports.ClientAdFreshStatus.encode(message.adFreshStatus, writer.uint32(106).fork()).ldelim();
        }
        if (message.displayedPreRollAdInfo !== undefined) {
            inventory_request_1.DisplayedPreRollAdInfo.encode(message.displayedPreRollAdInfo, writer.uint32(114).fork()).ldelim();
        }
        if (message.serveItemId.length !== 0) {
            writer.uint32(122).bytes(message.serveItemId);
        }
        for (const v of message.clientAttemptedCrawls) {
            client_crawl_attempt_1.ClientCrawlAttempt.encode(v, writer.uint32(130).fork()).ldelim();
        }
        if (message.isIntermediateTrack !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isIntermediateTrack }, writer.uint32(138).fork()).ldelim();
        }
        if (message.adTrackTriggerType !== 0) {
            writer.uint32(144).int32(message.adTrackTriggerType);
        }
        if (message.adViewSeqNum !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.adViewSeqNum }, writer.uint32(154).fork()).ldelim();
        }
        if (message.isSpectrumTrackEnabled !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isSpectrumTrackEnabled }, writer.uint32(162).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdTrackItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.encryptedAdTrackData = reader.bytes();
                    break;
                case 2:
                    message.impressionData = impression_data_1.ImpressionData.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sessionId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.trackSeqNum = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.attemptSeqNum = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.clientRankingNoShow = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.clientRankingModelOutput = exports.ClientRankingModelOutput.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.clientRankingFeatures = exports.ClientRankingFeatures.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.opportunityRequestId = reader.bytes();
                    break;
                case 10:
                    message.RTBTrackData = rtb_track_data_1.RTBTrackData.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.failureToDeliverReason = exports.FailureToDeliverReason.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.adInsertionConfig = ad_insertion_config_1.AdInsertionConfig.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.adFreshStatus = exports.ClientAdFreshStatus.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.displayedPreRollAdInfo = inventory_request_1.DisplayedPreRollAdInfo.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.serveItemId = reader.bytes();
                    break;
                case 16:
                    message.clientAttemptedCrawls.push(client_crawl_attempt_1.ClientCrawlAttempt.decode(reader, reader.uint32()));
                    break;
                case 17:
                    message.isIntermediateTrack = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 18:
                    message.adTrackTriggerType = reader.int32();
                    break;
                case 19:
                    message.adViewSeqNum = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 20:
                    message.isSpectrumTrackEnabled = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdTrackItem();
        message.encryptedAdTrackData =
            object.encryptedAdTrackData ?? new Uint8Array();
        message.impressionData =
            object.impressionData !== undefined && object.impressionData !== null
                ? impression_data_1.ImpressionData.fromPartial(object.impressionData)
                : undefined;
        message.sessionId = object.sessionId ?? undefined;
        message.trackSeqNum = object.trackSeqNum ?? undefined;
        message.attemptSeqNum = object.attemptSeqNum ?? undefined;
        message.clientRankingNoShow = object.clientRankingNoShow ?? undefined;
        message.clientRankingModelOutput =
            object.clientRankingModelOutput !== undefined &&
                object.clientRankingModelOutput !== null
                ? exports.ClientRankingModelOutput.fromPartial(object.clientRankingModelOutput)
                : undefined;
        message.clientRankingFeatures =
            object.clientRankingFeatures !== undefined &&
                object.clientRankingFeatures !== null
                ? exports.ClientRankingFeatures.fromPartial(object.clientRankingFeatures)
                : undefined;
        message.opportunityRequestId =
            object.opportunityRequestId ?? new Uint8Array();
        message.RTBTrackData =
            object.RTBTrackData !== undefined && object.RTBTrackData !== null
                ? rtb_track_data_1.RTBTrackData.fromPartial(object.RTBTrackData)
                : undefined;
        message.failureToDeliverReason =
            object.failureToDeliverReason !== undefined &&
                object.failureToDeliverReason !== null
                ? exports.FailureToDeliverReason.fromPartial(object.failureToDeliverReason)
                : undefined;
        message.adInsertionConfig =
            object.adInsertionConfig !== undefined &&
                object.adInsertionConfig !== null
                ? ad_insertion_config_1.AdInsertionConfig.fromPartial(object.adInsertionConfig)
                : undefined;
        message.adFreshStatus =
            object.adFreshStatus !== undefined && object.adFreshStatus !== null
                ? exports.ClientAdFreshStatus.fromPartial(object.adFreshStatus)
                : undefined;
        message.displayedPreRollAdInfo =
            object.displayedPreRollAdInfo !== undefined &&
                object.displayedPreRollAdInfo !== null
                ? inventory_request_1.DisplayedPreRollAdInfo.fromPartial(object.displayedPreRollAdInfo)
                : undefined;
        message.serveItemId = object.serveItemId ?? new Uint8Array();
        message.clientAttemptedCrawls =
            object.clientAttemptedCrawls?.map((e) => client_crawl_attempt_1.ClientCrawlAttempt.fromPartial(e)) || [];
        message.isIntermediateTrack = object.isIntermediateTrack ?? undefined;
        message.adTrackTriggerType = object.adTrackTriggerType ?? 0;
        message.adViewSeqNum = object.adViewSeqNum ?? undefined;
        message.isSpectrumTrackEnabled = object.isSpectrumTrackEnabled ?? undefined;
        return message;
    },
};
function createBaseFailureToDeliverReason() {
    return { reason: 0, additionalInfo: undefined };
}
exports.FailureToDeliverReason = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.reason !== 0) {
            writer.uint32(8).int32(message.reason);
        }
        if (message.additionalInfo !== undefined) {
            wrappers_1.StringValue.encode({ value: message.additionalInfo }, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFailureToDeliverReason();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.reason = reader.int32();
                    break;
                case 2:
                    message.additionalInfo = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFailureToDeliverReason();
        message.reason = object.reason ?? 0;
        message.additionalInfo = object.additionalInfo ?? undefined;
        return message;
    },
};
function createBaseClientRankingModelOutput() {
    return {
        modelId: undefined,
        score: undefined,
        inferenceLatency: undefined,
        loadingLatency: undefined,
        error: undefined,
    };
}
exports.ClientRankingModelOutput = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.modelId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.modelId }, writer.uint32(10).fork()).ldelim();
        }
        if (message.score !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.score }, writer.uint32(18).fork()).ldelim();
        }
        if (message.inferenceLatency !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.inferenceLatency }, writer.uint32(26).fork()).ldelim();
        }
        if (message.loadingLatency !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.loadingLatency }, writer.uint32(34).fork()).ldelim();
        }
        if (message.error !== undefined) {
            wrappers_1.StringValue.encode({ value: message.error }, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientRankingModelOutput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.modelId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.score = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.inferenceLatency = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.loadingLatency = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.error = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseClientRankingModelOutput();
        message.modelId = object.modelId ?? undefined;
        message.score = object.score ?? undefined;
        message.inferenceLatency = object.inferenceLatency ?? undefined;
        message.loadingLatency = object.loadingLatency ?? undefined;
        message.error = object.error ?? undefined;
        return message;
    },
};
function createBaseClientRankingFeatures() {
    return {
        appVersion: undefined,
        deviceOs: 0,
        totalUniqueSnapsViewed: undefined,
        numOfTapBacks: undefined,
        playList: undefined,
        playbackAudio: 0,
        postRoll: undefined,
        snapIndexPosition: undefined,
        timeViewedArray: [],
        totalUniqueSnaps: undefined,
        isLastSnapVideo: undefined,
        totalUniqueAdsViewed: undefined,
    };
}
exports.ClientRankingFeatures = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.appVersion !== undefined) {
            wrappers_1.StringValue.encode({ value: message.appVersion }, writer.uint32(10).fork()).ldelim();
        }
        if (message.deviceOs !== 0) {
            writer.uint32(16).int32(message.deviceOs);
        }
        if (message.totalUniqueSnapsViewed !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalUniqueSnapsViewed }, writer.uint32(26).fork()).ldelim();
        }
        if (message.numOfTapBacks !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.numOfTapBacks }, writer.uint32(34).fork()).ldelim();
        }
        if (message.playList !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.playList }, writer.uint32(42).fork()).ldelim();
        }
        if (message.playbackAudio !== 0) {
            writer.uint32(48).int32(message.playbackAudio);
        }
        if (message.postRoll !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.postRoll }, writer.uint32(58).fork()).ldelim();
        }
        if (message.snapIndexPosition !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.snapIndexPosition }, writer.uint32(66).fork()).ldelim();
        }
        for (const v of message.timeViewedArray) {
            wrappers_1.FloatValue.encode({ value: v }, writer.uint32(74).fork()).ldelim();
        }
        if (message.totalUniqueSnaps !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalUniqueSnaps }, writer.uint32(82).fork()).ldelim();
        }
        if (message.isLastSnapVideo !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isLastSnapVideo }, writer.uint32(90).fork()).ldelim();
        }
        if (message.totalUniqueAdsViewed !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalUniqueAdsViewed }, writer.uint32(98).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientRankingFeatures();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.appVersion = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.deviceOs = reader.int32();
                    break;
                case 3:
                    message.totalUniqueSnapsViewed = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.numOfTapBacks = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.playList = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.playbackAudio = reader.int32();
                    break;
                case 7:
                    message.postRoll = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.snapIndexPosition = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.timeViewedArray.push(wrappers_1.FloatValue.decode(reader, reader.uint32()).value);
                    break;
                case 10:
                    message.totalUniqueSnaps = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.isLastSnapVideo = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.totalUniqueAdsViewed = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseClientRankingFeatures();
        message.appVersion = object.appVersion ?? undefined;
        message.deviceOs = object.deviceOs ?? 0;
        message.totalUniqueSnapsViewed = object.totalUniqueSnapsViewed ?? undefined;
        message.numOfTapBacks = object.numOfTapBacks ?? undefined;
        message.playList = object.playList ?? undefined;
        message.playbackAudio = object.playbackAudio ?? 0;
        message.postRoll = object.postRoll ?? undefined;
        message.snapIndexPosition = object.snapIndexPosition ?? undefined;
        message.timeViewedArray = object.timeViewedArray?.map((e) => e) || [];
        message.totalUniqueSnaps = object.totalUniqueSnaps ?? undefined;
        message.isLastSnapVideo = object.isLastSnapVideo ?? undefined;
        message.totalUniqueAdsViewed = object.totalUniqueAdsViewed ?? undefined;
        return message;
    },
};
function createBaseClientAdFreshStatus() {
    return { freshStatus: 0 };
}
exports.ClientAdFreshStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.freshStatus !== 0) {
            writer.uint32(8).int32(message.freshStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientAdFreshStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.freshStatus = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseClientAdFreshStatus();
        message.freshStatus = object.freshStatus ?? 0;
        return message;
    },
};
class AdTrackServiceClientImpl {
    rpc;
    constructor(rpc) {
        this.rpc = rpc;
        this.AdTrackRequest = this.AdTrackRequest.bind(this);
    }
    AdTrackRequest(request, metadata) {
        return this.rpc.unary(exports.AdTrackServiceAdTrackRequestDesc, exports.TrackRequest.fromPartial(request), metadata);
    }
}
exports.AdTrackServiceClientImpl = AdTrackServiceClientImpl;
exports.AdTrackServiceDesc = {
    serviceName: "snapchat.ads.request.schema.AdTrackService",
};
exports.AdTrackServiceAdTrackRequestDesc = {
    methodName: "AdTrackRequest",
    service: exports.AdTrackServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.TrackRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...track_response_1.TrackResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
class GrpcWebImpl {
    host;
    options;
    constructor(host, options) {
        this.host = host;
        this.options = options;
    }
    unary(methodDesc, _request, metadata) {
        const request = { ..._request, ...methodDesc.requestType };
        const maybeCombinedMetadata = metadata && this.options.metadata
            ? new browser_headers_1.BrowserHeaders({
                ...this.options?.metadata.headersMap,
                ...metadata?.headersMap,
            })
            : metadata || this.options.metadata;
        return new Promise((resolve, reject) => {
            grpc_web_1.grpc.unary(methodDesc, {
                request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function (response) {
                    if (response.status === grpc_web_1.grpc.Code.OK) {
                        resolve(response.message);
                    }
                    else {
                        const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
                        reject(err);
                    }
                },
            });
        });
    }
}
exports.GrpcWebImpl = GrpcWebImpl;
class GrpcWebError extends Error {
    code;
    metadata;
    constructor(message, code, metadata) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
exports.GrpcWebError = GrpcWebError;
//# sourceMappingURL=track_request.js.map